const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export async function sendReportByData({ to, subject, reportData }) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 15000); // 15 segundos timeout (menos porque no enviamos HTML)
  
  try {
    const res = await fetch(`${API_URL}/email/send-report`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ to, subject, reportData }),
      signal: controller.signal,
    });
    
    clearTimeout(timeoutId);
    
    if (!res.ok) {
      const errorText = await res.text();
      throw new Error(`HTTP ${res.status}: ${errorText}`);
    }
    
    return res.json();
  } catch (error) {
    clearTimeout(timeoutId);
    
    if (error.name === 'AbortError') {
      throw new Error('El envío del reporte está tardando más de lo esperado. Se procesará en segundo plano.');
    }
    
    throw error;
  }
}
